export default __webpack_public_path__ + "static/media/Kadir.4739f0e4.jpeg";